namespace MACRAIL.UI {

export class QrCode {

    public static show(rootElement: HTMLElement, file: string) {
        let name = rootElement.dataset.qrcodeName;
        let data = rootElement.dataset.qrcodeContent;

        // Assemble model content
        let body = $(`
            <div id="qrcode-modal-content" style="text-align: center;">
                <p>Scan this QR Code with your mobile to view.</p>
            </div>
        `);

        let qrCodeDiv = $(`<div style="margin: 20px; text-align: center;"></div>`);
        body.append(qrCodeDiv);

        // If a URL, add a link.
        if (data.substring(0, 4) == 'http') {
            body.append('<p style="margin: 20px;"><a target="_blank" href="' + data + '">Open link</a></p>');
        }

        if (name) {
            let downloadBtn = $('<button class="btn btn-primary">Download</button>');
            let downloadP = $(`<p></p>`).append(downloadBtn);
            body.append(downloadP);

            downloadBtn.on('click', function() {
                var dataUrl = qrCodeDiv.find('canvas')[0].toDataURL();

                var anchor = document.createElement('a');
                anchor.href = dataUrl;

                anchor.download = 'QR Code - ' + name.replace(/[^a-zA-z0-9 -\(\)]/g, '');

                anchor.click();
                anchor.remove();
            });
        }

        let title = 'QR Code';

        if (name) {
            title += ': ' + name;
        }

        let qrCodeModal = new MACRAIL.Modal({
            'id': 'qrcode-modal',
            'title': title,
            'body': body,
            // 'dialogClass': 'modal-lg',
            'buttons': MACRAIL.Modal.defaultButtonGroups.close,
            'destroyOnClose': true,
        });

        // @ts-ignore
        new QRCode(qrCodeDiv[0], data);

        setTimeout(function() {
            qrCodeDiv.find('img').css('display', '');
        }, 1);

        qrCodeModal.show();
    }
}

}
